export const API_URLS = {
  login: "api/login/",
  verifyOTP: "api/verify-login-otp/",
  productList: "api/api-product-list-by-near-store/",
  productSortBy: "api/filter-product-list",
  productDetails: "api/product-deatils/",
  updateProfile: "api/update-profile/",
  profile: "api/my-profile/",
  myOrders: "api/my-order/",
  myWishList: "api/wishlist-list/",
  addToWishList: "api/add-to-wishlist/",
  removeWishList: "api/remove-from-wishlist/",
  addressList: "api/my-address-list/",
  cityList: "api/city-list/",
  stateList: "api/state-list/",
  countryList: "api/country-list/",
  addAddress: "api/add-new-address/",
  privacyPolicy: "api/privacy-policy/",
  contactUs: "api/contact-us/",
  writeReviw: "api/write-review/",
  addToCart: "api/add-to-cart/",
  cartList: "api/cart-list/",
  removeCartItem: "api/remove-from-cart/",
  increaseCart: "api/increase-product-quantity-from-cart/",
  decreaseCart: "api/decrease-product-quantity-from-cart/",
  paymentReceipt: "api/create-payment-receipt/",
  clearCart: "api/clear-cart/",
  checkOut: "api/order-checkout/",
  sliderList: "api/slider-list/",
  updateAddress: "api/update-address/",
  deleteUpdate: "api/delete-address/",
  checkPincode: "api/order-delivery-time-by-city/",
  orderCancellation: "api/order-cancellation-section/",
  categoryList: "api/overall-main-category-sub-category-list/",
  brandList: "api/brand-list/",
  allFilters: "api/all-filter-product-list",
  resonsForCancellation: "api/reason-for-cancellation-list/",
  testimonial: "api/amaka/web-testimonials/",
  banner: "api/amaka/web-category-banner-list/",
  codCheckout: "api/order-checkout-cash-on-delivery/",
  invoiceDetail: "api/amaka-get-single-invoice-details/",
  invoiceList: "api/amaka-get-all-order-data/",
  createInvoice: "api/amaka-create-invoice/",
  dailySubscription:"api/buy-daily-subscription-plan-with-poductvariant/",
  monthlySubscription:"api/buy-monthly-subscription-plan-with-poductvariant/",
  weeklySubscription :"api/buy-weekly-subscription-plan-with-poductvariant/",
  subscriptionList: "api/product-variants-subscription-list/",
  showSubscription:"api/multivendor-show-subscription-plan-details/",
  recommandedProducts: "api/get-recommanded-products-data/",
  topRatedProducts: "api/show-top-rated-variants-data/",
  mostViewedProducts: "api/show-mostviewed-product-variants-data/",
  banners: "api/updated-api-banner-list/",
};
